













































import VueOptions from '@utils/VueOptions'

settings = 
  name: 'PricingModel'

  vue:
    props: ['pricingTable', 'specialPricingTable', 'actions']

    methods:
      isSpecial: (pricingModel, definition) ->
        definition.style is 'special' && @specialPricingTable?[pricingModel]?.style is 'special'

      isContextSpecial: (pricingModel, definition) ->
        definition.style is 'special' && @specialPricingTable?[pricingModel]?.style isnt 'special'

    filters:
      mapSpecialTableKlass: (klass) ->
        map =
          audience_creative: 'experience'
        map[klass] || klass

export default VueOptions.vue settings
